import { useState } from "react";

// components
import Button from "../../../../components/Button/Button";
import Typography from "../../../../components/Typography/Typography";
import { Table } from "../../../../components/Table/Table";

// styled components
import { Container, Wrapper, WrapperBtn } from "./smdComponentStyle";

const SmsComponentManagement = () => {
  const [type, setType] = useState("سفارش جدید");

  return (
    <Container>
      <Wrapper>
        <WrapperBtn>
          <Button
            bgColor={type === "سفارش جدید" ? "#009EF7" : "transparent"}
            border="#009EF7"
            onclick={() => setType("سفارش جدید")}
            color={type === "سفارش جدید" && "#fff"}
          >
            <Typography size="14px" primary={type === "سفارش جدید" && "#fff"}>
              سفارش جدید
            </Typography>
          </Button>
        </WrapperBtn>
        <WrapperBtn>
          <Button
            border="#F1416C"
            bgColor={
              type === "ویرایش پروفایل کاربر" ? "#F1416C" : "transparent"
            }
            onclick={() => setType("ویرایش پروفایل کاربر")}
            color={type === "ویرایش پروفایل کاربر" && "#fff"}
          >
            <Typography
              size="14px"
              primary={type === "ویرایش پروفایل کاربر" && "#fff"}
            >
              ویرایش پروفایل کاربر
            </Typography>
          </Button>
        </WrapperBtn>
        <WrapperBtn>
          <Button
            border="#50CD89"
            bgColor={type === "ثبت نام جدید" ? "#50CD89" : "transparent"}
            color={type === "ثبت نام جدید" && "#fff"}
            onclick={() => setType("ثبت نام جدید")}
          >
            <Typography size="14px" primary={type === "ثبت نام جدید" && "#fff"}>
              ثبت نام جدید
            </Typography>
          </Button>
        </WrapperBtn>
      </Wrapper>
      <Table title={`لیست ${type}`} />
    </Container>
  );
};

export default SmsComponentManagement;
